/** Sentinel value for client Select dropdowns: opens add-client dialog instead of selecting. */
export const CLIENT_SELECT_ADD_NEW_VALUE = "__add_client__";
